/**
 * Chiude la sessione quando il backend rifiuta il token.
 *
 * Un token puo' diventare invalido prima della scadenza: cambio password o "esci da tutti gli altri
 * dispositivi" fatti da un altro dispositivo, oppure disattivazione dell'utente. Senza questo
 * interceptor il BO resterebbe aperto con ogni chiamata in errore fino al reload della pagina.
 *
 * Si reagisce SOLO al 401 dei middleware di autenticazione, che rispondono `{ message: 401 }`:
 * il login risponde 401 con i codici 1003/1005/1009 e non deve sloggare nessuno.
 * Il rinnovo (`auth/token`) e' escluso perche' lo gestisce gia' `checkauth` in src/Helper.js.
 *
 * Installato una sola volta su `axios` in src/main.js.
 */
export function installSessionGuard(axios, store, router) {
	axios.interceptors.response.use(
		response => response,
		error => {
			const response = error && error.response;
			const url = (error && error.config && error.config.url) || '';

			if (response && response.status === 401 && response.data && response.data.message === 401 && !url.endsWith('auth/token')) {
				// partner e affiliati hanno token e area propri: si chiude solo la loro sessione
				if (url.includes('partner-program') || url.includes('partner-auth')) {
					store.dispatch('partnerprogram/logout');
				} else if (url.includes('affiliate-program') || url.includes('affiliate-auth')) {
					store.dispatch('affiliateprogram/logout');
				} else if (localStorage.getItem('token')) {
					store.dispatch('profile/logout');
					if (router.currentRoute.path !== '/login') {
						router.push('/login').catch(() => {});
					}
				}
			}

			return Promise.reject(error);
		},
	);
}

export default installSessionGuard;
